import { render, staticRenderFns } from "./BaseKinostart.vue?vue&type=template&id=13de794a&scoped=true&"
import script from "./BaseKinostart.vue?vue&type=script&lang=js&"
export * from "./BaseKinostart.vue?vue&type=script&lang=js&"
import style0 from "./BaseKinostart.vue?vue&type=style&index=0&id=13de794a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13de794a",
  null
  
)

export default component.exports